<template>
    <div class="progress" :style="height ? `height: ${height}` : ''" v-if="error">
        <div style="width: 100%" :class="barClass">{{ errorMessage || 'Fehler!' }}</div>
    </div>
    <div class="progress" :style="height ? `height: ${height}` : ''" v-else>
        <div :style="`width: ${progress}%`" :class="barClass"><slot/></div>
    </div>
</template>

<script>
    export default {
        props: {
            error: {
                type: Boolean,
                default: false,
            },
            errorMessage: {
                type: String,
            },
            animated: {
                type: Boolean,
                default: false,
            },
            striped: {
                type: Boolean,
                default: false,
            },
            color: {
                type: String,
                default: '',
            },
            height: {
                type: String,
                default: '',
            },
            progress: {
                default: '100',
            },
        },

        computed: {
            barClass() {
                return {
                    'progress-bar': true,
                    'progress-bar-striped': this.striped,
                    'progress-bar-animated': this.animated,
                    'bg-danger': this.error,
                    [`bg-${this.color}`]: this.color && !this.error,
                };
            },
        },
    };
</script>
